import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Super-admin is English only, but the shared components (the sign-in page
// among them) call t(). Their keys are the English source strings, so an
// instance with no dictionaries renders them as-is — and, unlike having no
// instance at all, still fills in {{placeholders}}.
void i18n.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: false,
  resources: {},
  keySeparator: false,
  nsSeparator: false,
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
